module.exports = __webpack_public_path__ + "static/step-6ce4b09363b2071d96a9cff292d1d1fa.svg";